import END_POINT from 'src/config/endpoints.constants';
import { ApiResponse, ApiResult, getErrorMessage } from '../lib/API';
import { AnswerCallDetail, UUID } from '../types';
import axios from 'axios';
export interface AnswerCallResult extends ApiResult {
    data?: {
        callDetail: AnswerCallDetail;
    };
}

export interface AnswerCallResponse extends ApiResponse {
    data: AnswerCallDetail;
}

export interface AnswerCallOptions {
    requestId: UUID;
    deviceId: UUID;
}

export default async function answerCall(options: AnswerCallOptions, config: any = {}) {
    const result: AnswerCallResult = {};
    try {
        const { data: responseData } = await axios.post<AnswerCallResponse>(
            END_POINT.JOIN_ROOM,
            options,
            config,
        );
        if (responseData) {
            if (responseData.code === 0) {
                result.data = {
                    callDetail: responseData.data,
                };
            } else {
                result.error = responseData.message;
            }
        }
    } catch (error) {
        result.error = getErrorMessage(error);
    }
    return result;
}
